//variables that will be used in each conditionals function of the super object
let level = 'Unknown Range';
let colour = undefined;

/**
 * Object containing ranges and conditionals for different vital titles.
 * @type {Object.<string, RangesAndConditionals>}
 */
export const rangesAndConditionalsByVitalTitle = {
  'Pulse Rate': {
    range: [
      {position: 0.0, color: '#feec88'},
      {position: 60.0, color: '#feec88'},
      {position: 60.0, color: '#62da9a'},
      {position: 100.0, color: '#62da9a'},
      {position: 100.0, color: '#fd5757'},
      {position: 220.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 220, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 60) {
        level = isModalPopup ? 'Low range\n< 60' : 'Low range';
        colour = '#feec88';
      } else if (result >= 60 && result <= 100) {
        level = isModalPopup ? 'Normal range\n60-100' : 'Normal range';
        colour = '#62da9a';
      } else if (result > 100) {
        level = isModalPopup ? 'High range\n100+' : 'High range';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Breathing Rate': {
    range: [
      {position: 0.0, color: '#feec88'},
      {position: 12.0, color: '#feec88'},
      {position: 12.0, color: '#62da9a'},
      {position: 20.0, color: '#62da9a'},
      {position: 20.0, color: '#fd5757'},
      {position: 50.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 50, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 12) {
        level = isModalPopup ? 'Low range\n< 12' : 'Low range';
        colour = '#feec88';
      } else if (result >= 12 && result <= 20) {
        level = isModalPopup ? 'Normal range\n12-20' : 'Normal range';
        colour = '#62da9a';
      } else if (result > 20) {
        level = isModalPopup ? 'High range\n20+' : 'High range';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Blood Pressure': {
    conditionals: (result, isModalPopup) => {
      if (result[0] < 90) {
        level = 'Low range';
        colour = '#f2d53a';
      } else if (result[0] >= 90 && result[0] < 120) {
        level = 'Normal range';
        colour = '#62da9a';
      } else if (result[0] >= 120 && result[0] <= 135) {
        level = 'Medium risk';
        colour = '#feec88';
      } else if (result[0] > 135) {
        level = 'High range';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Systolic Blood Pressure': {
    range: [
      {position: 0.0, color: '#feec88'},
      {position: 90.0, color: '#feec88'},
      {position: 90.0, color: '#62da9a'},
      {position: 120.0, color: '#62da9a'},
      {position: 120.0, color: '#fd5757'},
      {position: 180.0, color: '#fd5757'},
    ],

    fitToPercentageProps: [0, 180, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 90) {
        level = isModalPopup ? 'Low range\n< 90' : 'Low range';
        colour = '#f2d53a';
      } else if (result >= 90 && result < 120) {
        level = isModalPopup ? 'Normal range\n90-120' : 'Normal range';
        colour = '#62da9a';
      } else if (result >= 120 && result <= 135) {
        level = isModalPopup ? 'Medium risk\n120-135' : 'Medium risk';
        colour = '#fd5757';
      } else if (result > 135) {
        level = isModalPopup ? 'High range\n135+' : 'High range';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Diastolic Blood Pressure': {
    range: [
      {position: 0.0, color: '#feec88'},
      {position: 60.0, color: '#feec88'},
      {position: 60.0, color: '#62da9a'},
      {position: 80.0, color: '#62da9a'},
      {position: 80.0, color: '#fd5757'},
      {position: 120.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 120, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 60) {
        level = isModalPopup ? 'Low range\n< 60' : 'Low range';
        colour = '#feec88';
      } else if (result >= 60 && result <= 80) {
        level = isModalPopup ? 'Normal range\n60-80' : 'Normal range';
        colour = '#62da9a';
      } else if (result > 80) {
        level = isModalPopup ? 'High range\n80+' : 'High range';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Heart Rate Variability': {
    range: [
      {position: 0.0, color: '#fd5757'},
      {position: 16.4, color: '#fd5757'},
      {position: 16.4, color: '#feec88'},
      {position: 35.5, color: '#feec88'},
      {position: 35.5, color: '#62da9a'},
      {position: 300.0, color: '#62da9a'},
    ],
    fitToPercentageProps: [0, 300, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 16.4) {
        level = isModalPopup ? 'High risk\n< 16.4' : 'High risk';
        colour = '#fd5757';
      } else if (result >= 16.4 && result < 35.5) {
        level = isModalPopup ? 'Low risk\n16.4-35.5' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 35.5) {
        level = isModalPopup ? 'Normal\n35.5+' : 'Normal';
        colour = '#62da9a';
      }
      return {level, colour};
    },
  },
  'Cardiac Workload': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 3.9, color: '#62da9a'},
      {position: 3.9, color: '#feec88'},
      {position: 4.08, color: '#feec88'},
      {position: 4.08, color: '#fd5757'},
      {position: 5, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 5, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 3.9) {
        level = isModalPopup ? 'Normal\n< 3.9' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 3.9 && result < 4.08) {
        level = isModalPopup ? 'Low risk\n3.9-4.08' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 4.08) {
        level = isModalPopup ? 'High risk\n4.08+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Vascular Capacity': {
    range: [
      {position: 0.0, color: '#fd5757'},
      {position: 1.12, color: '#fd5757'},
      {position: 1.12, color: '#feec88'},
      {position: 1.78, color: '#feec88'},
      {position: 1.78, color: '#62da9a'},
      {position: 3.0, color: '#62da9a'},
    ],
    fitToPercentageProps: [0, 3, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 1.12) {
        level = isModalPopup ? 'High risk\n< 1.12' : 'High risk';
        colour = '#fd5757';
      } else if (result >= 1.12 && result < 1.78) {
        level = isModalPopup ? 'Low risk\n1.12-1.78' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 1.78) {
        level = isModalPopup ? 'Normal\n1.78+' : 'Normal';
        colour = '#62da9a';
      }
      return {level, colour};
    },
  },
  'Mental Stress Index': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 3.0, color: '#62da9a'},
      {position: 3.0, color: '#feec88'},
      {position: 4.0, color: '#feec88'},
      {position: 4.0, color: '#fd5757'},
      {position: 10.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 10, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 3.0) {
        level = isModalPopup ? 'Normal\n< 3.0' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 3.0 && result < 4.0) {
        level = isModalPopup ? 'Low risk\n3.0-4.0' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 4.0) {
        level = isModalPopup ? 'High risk\n4.0+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Body Mass Index': {
    range: [
      {position: 0.0, color: '#feec88'},
      {position: 18.5, color: '#feec88'},
      {position: 18.5, color: '#62da9a'},
      {position: 25.0, color: '#62da9a'},
      {position: 25.0, color: '#feec88'},
      {position: 30.0, color: '#feec88'},
      {position: 30.0, color: '#ff8989'},
      {position: 35.0, color: '#ff8989'},
      {position: 35.0, color: '#fd5757'},
      {position: 60.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 60, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result >= 0.0 && result < 18.5) {
        level = isModalPopup ? 'Underweight\n0.0-18.5' : 'Underweight';
        colour = '#feec88';
      } else if (result >= 18.5 && result < 25.0) {
        level = isModalPopup ? 'Normal weight\n18.5-25.0' : 'Normal weight';
        colour = '#62da9a';
      } else if (result >= 25.0 && result < 30.0) {
        level = isModalPopup ? 'Pre-obesity\n25.0-30.0' : 'Pre-obesity';
        colour = '#feec88';
      } else if (result >= 30.0 && result < 35.0) {
        level = isModalPopup ? 'Obesity Class I\n30.0-35.0' : 'Obesity Class I';
        colour = '#ff8989';
      } else if (result >= 35.0 && result < 40.0) {
        level = isModalPopup ? 'Obesity Class II\n35.0-40.0' : 'Obesity Class II';
        colour = '#fd5757';
      } else if (result >= 40.0) {
        level = isModalPopup ? 'Obesity Class III\n40.0+' : 'Obesity Class III';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Risk of HbA1c': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 45.0, color: '#62da9a'},
      {position: 45.0, color: '#feec88'},
      {position: 55, color: '#feec88'},
      {position: 55, color: '#fd5757'},
      {position: 100.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 100, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 45.0) {
        level = isModalPopup ? 'Normal\n< 45' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 45.0 && result < 55.0) {
        level = isModalPopup ? 'Low risk\n45.0-55.0' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 55.0) {
        level = isModalPopup ? 'High risk\n55+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Risk of Fasting Blood Glucose': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 45.0, color: '#62da9a'},
      {position: 45.0, color: '#feec88'},
      {position: 55, color: '#feec88'},
      {position: 55, color: '#fd5757'},
      {position: 100.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 100, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 45.0) {
        level = isModalPopup ? 'Normal\n< 45' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 45.0 && result < 55.0) {
        level = isModalPopup ? 'Low risk\n45.0-55.0' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 55.0) {
        level = isModalPopup ? 'High risk\n55+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Type II Diabetes Risk': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 45.0, color: '#62da9a'},
      {position: 45.0, color: '#feec88'},
      {position: 55, color: '#feec88'},
      {position: 55, color: '#fd5757'},
      {position: 100.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 100, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 45.0) {
        level = isModalPopup ? 'Normal\n< 45' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 45.0 && result < 55.0) {
        level = isModalPopup ? 'Low risk\n45.0-55.0' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 55.0) {
        level = isModalPopup ? 'High risk\n55+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Heart Attack Risk': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 2.39, color: '#62da9a'},
      {position: 2.39, color: '#feec88'},
      {position: 3.3, color: '#feec88'},
      {position: 3.3, color: '#fd5757'},
      {position: 100.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 100, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 2.39) {
        level = isModalPopup ? 'Normal\n< 2.39' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 2.39 && result < 3.3) {
        level = isModalPopup ? 'Low risk\n2.39-3.30' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 3.3) {
        level = isModalPopup ? 'High risk \n3.30+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Cardiovascular Disease Risk': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 7.25, color: '#62da9a'},
      {position: 7.25, color: '#feec88'},
      {position: 10.0, color: '#feec88'},
      {position: 10.0, color: '#fd5757'},
      {position: 100.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 100, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 7.25) {
        level = isModalPopup ? 'Normal\n< 7.25' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 7.25 && result < 10.0) {
        level = isModalPopup ? 'Low risk\n7.25-10' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 10.0) {
        level = isModalPopup ? 'High risk\n10+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Stroke Risk': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 4.79, color: '#62da9a'},
      {position: 4.79, color: '#feec88'},
      {position: 6.6, color: '#feec88'},
      {position: 6.6, color: '#fd5757'},
      {position: 100.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 100, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 4.79) {
        level = isModalPopup ? 'Normal\n< 4.79' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 4.79 && result < 6.6) {
        level = isModalPopup ? 'Low risk\n4.79-6.60' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 6.6) {
        level = isModalPopup ? 'High risk\n6.60+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Hypertriglyceridemia Risk': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 45.0, color: '#62da9a'},
      {position: 45.0, color: '#feec88'},
      {position: 55, color: '#feec88'},
      {position: 55, color: '#fd5757'},
      {position: 100.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 100, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 45.0) {
        level = isModalPopup ? 'Normal\n< 45' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 45.0 && result < 55.0) {
        level = isModalPopup ? 'Low risk\n45.0-55.0' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 55.0) {
        level = isModalPopup ? 'High risk\n55+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Hypercholesterolemia Risk': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 45.0, color: '#62da9a'},
      {position: 45.0, color: '#feec88'},
      {position: 55, color: '#feec88'},
      {position: 55, color: '#fd5757'},
      {position: 100.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 100, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 45.0) {
        level = isModalPopup ? 'Normal\n< 45' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 45.0 && result < 55.0) {
        level = isModalPopup ? 'Low risk\n45.0-55.0' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 55.0) {
        level = isModalPopup ? 'High risk\n55+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Hypertension Risk': {
    range: [
      {position: 0.0, color: '#62da9a'},
      {position: 45.0, color: '#62da9a'},
      {position: 45.0, color: '#feec88'},
      {position: 55, color: '#feec88'},
      {position: 55, color: '#fd5757'},
      {position: 100.0, color: '#fd5757'},
    ],
    fitToPercentageProps: [0, 100, 0, 100],
    conditionals: (result, isModalPopup) => {
      if (result < 45.0) {
        level = isModalPopup ? 'Normal\n< 45' : 'Normal';
        colour = '#62da9a';
      } else if (result >= 45.0 && result < 55.0) {
        level = isModalPopup ? 'Low risk\n45.0-55.0' : 'Low risk';
        colour = '#feec88';
      } else if (result >= 55.0) {
        level = isModalPopup ? 'High risk\n55+' : 'High risk';
        colour = '#fd5757';
      }
      return {level, colour};
    },
  },
  'Facial Skin Age': {
    conditionals: (result, userActualAge) => {
      let level = 'Older';
      let colour = '#feec88';
      if (result < userActualAge) {
        level = 'Younger';
        colour = '#62da9a';
      } else if (result == userActualAge) {
        level = 'Same';
        colour = '#92e5b7';
      }
      return {level, colour};
    },
  },
};
